// See useEventSessionScope.spec.md for ESCOPE-FR-001

import { shallowEqual } from 'react-redux'
import { useAppSelector } from 'app/store'
import { sessionStoreKey } from 'core/session/sessionReducers'

export interface EventSessionScope {
  // Whose last-seen time is read and saved (NB-FR-007)
  userId?: string
  // Only this region's resources link to their details pages (NCP-FR-010)
  activeRegion?: string | null
  // Tenant-scoped pages (snapshots) only open this tenant's resources (NCP-FR-010)
  activeTenantId?: string | null
}

// ESCOPE-FR-001: The session values the bar and the page read, selected together so a component
// re-renders only when one of them changes
export default function useEventSessionScope(): EventSessionScope {
  return useAppSelector((state) => {
    const session = state[sessionStoreKey]
    return {
      userId: session?.userDetails?.id,
      activeRegion: session?.activeRegion,
      activeTenantId: session?.activeTenantId,
    }
  }, shallowEqual)
}
